module.exports = __webpack_public_path__ + "img/省钱省力.a56d61b6.png";